import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

export const assignPermissionToRole = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.PERMISSIONS.UPDATE_PERMISSIONS,
      method: 'post',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
